import { ComponentMap } from '@cinch-nx/data-storyblok'
import { globalStoryblokComponents } from '@cinch-nx/storyblok'

import {
  HelpMeChoose,
  HomeHeroV2,
  PartExchangeSection,
  UspSlide,
  ValuePropositions,
  WhyCinch,
} from '../components'
import { landingStoryblokComponents } from '@cinch-nx/landing-ui-shared'

const localStoryblokComponents: ComponentMap = {
  HomeHeroV2: HomeHeroV2,
  HelpMeChooseSection: HelpMeChoose,
  WhyCinchSection: WhyCinch,
  PartExSection: PartExchangeSection,
  ValuePropsCard: ValuePropositions,
  HomeUspSlide: UspSlide,
  ...landingStoryblokComponents,
}

export const storyblokComponents = {
  ...globalStoryblokComponents,
  ...localStoryblokComponents,
}
